import { render, staticRenderFns } from "./PlayerSpace.vue?vue&type=template&id=b6d4f6da&scoped=true"
import script from "./PlayerSpace.vue?vue&type=script&lang=js"
export * from "./PlayerSpace.vue?vue&type=script&lang=js"
import style0 from "./PlayerSpace.vue?vue&type=style&index=0&id=b6d4f6da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d4f6da",
  null
  
)

export default component.exports